import { useState, useEffect } from 'react';
import { useRealScreenSize } from './use-real-screen-size.hook';
import { exactDeviceTypesEnum, generalDeviceTypesEnum } from '../enums/device-types.enum';

export const useDeviceTypeHook = (
    isTinyDesktopGenerallyMobile = true,
) => {
    const { width, isPortrait } = useRealScreenSize();
    const [isFinePointer, setIsFinePointer] = useState(false);
    const [isCoarsePointer, setIsCoarsePointer] = useState(true);
    const [generalDeviceType, setGeneralDeviceType] = useState(generalDeviceTypesEnum.MOBILE);
    const [exactDeviceType, setExactDeviceType] = useState(exactDeviceTypesEnum.MOBILE);

    // Check if device has high/low accuracy pointer as a main one
    useEffect(() => {
        const finePointerMedia = '(pointer: fine)';
        const finePointerMatch = window.matchMedia(finePointerMedia);
        const updateIsFinePointer = () => {
            setIsFinePointer(finePointerMatch.matches);
        };

        const coarsePointerMedia = '(pointer: coarse)';
        const coarsePointerMatch = window.matchMedia(coarsePointerMedia);
        const updateIsCoarsePointer = () => {
            setIsCoarsePointer(coarsePointerMatch.matches);
        };

        updateIsCoarsePointer();
        updateIsFinePointer();

        finePointerMatch.addEventListener('change', updateIsFinePointer);
        coarsePointerMatch.addEventListener('change', updateIsCoarsePointer);

        return () => {
            finePointerMatch.removeEventListener('change', updateIsFinePointer);
            coarsePointerMatch.removeEventListener('change', updateIsCoarsePointer);
        };
    }, []);

    useEffect(() => {
        if (isFinePointer && width >= 1024) {
            setGeneralDeviceType(generalDeviceTypesEnum.DESKTOP);
            setExactDeviceType(exactDeviceTypesEnum.DESKTOP);
        } else if (isFinePointer && width >= 800) {
            setGeneralDeviceType(isTinyDesktopGenerallyMobile
                ? generalDeviceTypesEnum.MOBILE
                : generalDeviceTypesEnum.DESKTOP
            );
            setExactDeviceType(exactDeviceTypesEnum.TINY_DESKTOP);
        } else if (isCoarsePointer && (
            isPortrait && width >= 744 ||
            !isPortrait && width >= 1280
        )) {
            setGeneralDeviceType(generalDeviceTypesEnum.DESKTOP);
            setExactDeviceType(exactDeviceTypesEnum.TABLET);
        } else {
            setGeneralDeviceType(generalDeviceTypesEnum.MOBILE);
            setExactDeviceType(exactDeviceTypesEnum.MOBILE);
        }
    }, [width, isPortrait, isFinePointer, isCoarsePointer]);

    return {
        isMobile: generalDeviceType === generalDeviceTypesEnum.MOBILE,
        generalType: generalDeviceType,
        exactType: exactDeviceType,
        isFinePointer,
        isCoarsePointer,
    };
};
